import React from "react";
import { TextInput, View } from "react-native";

import { FormInputProps } from "./FormInput.types";
import { useTheme } from "../../../structure";
import { Icon, Input, Label } from "../../basic";

export const FormInput = React.forwardRef(
  (
    { iconLeft, iconRight, input, label, message, state, isOptional, disabled }: FormInputProps,
    ref: React.Ref<TextInput>
  ) => {
    const { theme } = useTheme();
    return (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
          {label ? <Label type="l2Regular">{label}</Label> : null}
          {isOptional ? (
            <Label color={theme.colors.neutralLighter.contrast} type="l2Regular">
              Optional
            </Label>
          ) : null}
        </View>
        <View style={{ position: "relative", display: "flex", flexDirection: "row", alignItems: "center" }}>
          {iconLeft ? (
            <View style={{ position: "absolute", padding: 8 }}>
              <Icon color={theme.colors.neutralLighter.contrast} {...iconLeft} />
            </View>
          ) : null}
          <Input
            {...input}
            ref={ref}
            disabled={disabled}
            classNames={[
              "flex1",
              ...(input?.classNames || ["input", "inputLarge"]),
              iconLeft ? "pl32" : "",
              iconRight ? "pr32" : "",
              state ? "border" + state.charAt(0).toUpperCase() + state.slice(1) : "",
            ]}
          />
          {iconRight ? (
            <View style={{ padding: 8, right: 0, marginLeft: -40 }}>
              <Icon color={theme.colors.neutralLighter.contrast} {...iconRight} />
            </View>
          ) : null}
        </View>
        {message ? (
          <Label type="l4Regular" color={theme.colors.danger.main}>
            {message}
          </Label>
        ) : null}
      </View>
    );
  }
);
